import { Action } from '@ngrx/store';


import { SingleResponseModel } from '../../../../common/models/single-response.model';
import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';

import { SummaryOwnFinancingModel } from '../../models/summary-own-financing.model';


export enum OwnFinancingActionTypes {
  LoadOwnFinancings = '[OwnFinancing] Load OwnFinancings',
  LoadOwnFinancingsSuccess = '[OwnFinancing] Load OwnFinancings Success',
  LoadOwnFinancingsFailure = '[OwnFinancing] Load OwnFinancings Failure',

  LoadOwnFinancing = '[OwnFinancing] Load OwnFinancing',
  LoadOwnFinancingSuccess = '[OwnFinancing] Load OwnFinancing Success',
  LoadOwnFinancingFailure = '[OwnFinancing] Load OwnFinancing Failure',

  CreateOwnFinancing = '[OwnFinancing] Create OwnFinancing',
  CreateOwnFinancingSuccess = '[OwnFinancing] Create OwnFinancing Success',
  CreateOwnFinancingFailure = '[OwnFinancing] Create OwnFinancing Failure',

  UpdateOwnFinancing = '[OwnFinancing] Update OwnFinancing',
  UpdateOwnFinancingSuccess = '[OwnFinancing] Update OwnFinancing Success',
  UpdateOwnFinancingFailure = '[OwnFinancing] Update OwnFinancing Failure',

  DeleteOwnFinancing = '[OwnFinancing] Delete OwnFinancing',
  DeleteOwnFinancingSuccess = '[OwnFinancing] Delete OwnFinancing Success',
  DeleteOwnFinancingFailure = '[OwnFinancing] Delete OwnFinancing Failure',
}

/** Load all */

export class LoadOwnFinancings implements Action {
  readonly type = OwnFinancingActionTypes.LoadOwnFinancings;
  constructor(public payload: {filter: any}) {}
}

export class LoadOwnFinancingsSuccess implements Action {
  readonly type = OwnFinancingActionTypes.LoadOwnFinancingsSuccess;
  constructor(public payload: { items: SummaryOwnFinancingModel[]; total: number }) {}
}

export class LoadOwnFinancingsFailure implements Action {
  readonly type = OwnFinancingActionTypes.LoadOwnFinancingsFailure;
  constructor(public payload: { error: any }) {}
}

/** Load by id */

export class LoadOwnFinancing implements Action {
  readonly type = OwnFinancingActionTypes.LoadOwnFinancing;
  constructor(public payload: { uid: string }) {}
}

export class LoadOwnFinancingSuccess implements Action {
  readonly type = OwnFinancingActionTypes.LoadOwnFinancingSuccess;
  constructor(public payload: SingleResponseModel<SummaryOwnFinancingModel>) {}
}

export class LoadOwnFinancingFailure implements Action {
  readonly type = OwnFinancingActionTypes.LoadOwnFinancingFailure;
  constructor(public payload: { error: any }) {}
}

/** Create */

export class CreateOwnFinancing implements Action {
  readonly type = OwnFinancingActionTypes.CreateOwnFinancing;
  constructor(public payload: { ownFinancing: SummaryOwnFinancingModel }) {}
}


export class CreateOwnFinancingSuccess implements Action {
  readonly type = OwnFinancingActionTypes.CreateOwnFinancingSuccess;
  constructor(public payload: { ownFinancing: SummaryOwnFinancingModel }) {}
}

export class CreateOwnFinancingFailure implements Action {
  readonly type = OwnFinancingActionTypes.CreateOwnFinancingFailure;
  constructor(public payload: { error: any }) {}
}


/** Update */

export class UpdateOwnFinancing implements Action {
  readonly type = OwnFinancingActionTypes.UpdateOwnFinancing;
  constructor(public payload: { ownFinancing: SummaryOwnFinancingModel }) {}
}

export class UpdateOwnFinancingSuccess implements Action {
  readonly type = OwnFinancingActionTypes.UpdateOwnFinancingSuccess;
  constructor(public payload: { ownFinancing: SummaryOwnFinancingModel }) {}
}

export class UpdateOwnFinancingFailure implements Action {
  readonly type = OwnFinancingActionTypes.UpdateOwnFinancingFailure;
  constructor(public payload: { error: any }) {}
}


/** Delete */

export class DeleteOwnFinancing implements Action {
  readonly type = OwnFinancingActionTypes.DeleteOwnFinancing;
  constructor(public payload: { uid: string }) {}
}

export class DeleteOwnFinancingSuccess implements Action {
  readonly type = OwnFinancingActionTypes.DeleteOwnFinancingSuccess;
  constructor(public payload: { uid: string }) {}
}

export class DeleteOwnFinancingFailure implements Action {
  readonly type = OwnFinancingActionTypes.DeleteOwnFinancingFailure;
  constructor(public payload: { error: any }) {}
}

export type OwnFinancingActions =
  | LoadOwnFinancings
  | LoadOwnFinancingsSuccess
  | LoadOwnFinancingsFailure
  | LoadOwnFinancing
  | LoadOwnFinancingSuccess
  | LoadOwnFinancingFailure
  | CreateOwnFinancing
  | CreateOwnFinancingSuccess
  | CreateOwnFinancingFailure
  | UpdateOwnFinancing
  | UpdateOwnFinancingSuccess
  | UpdateOwnFinancingFailure
  | DeleteOwnFinancing
  | DeleteOwnFinancingSuccess
  | DeleteOwnFinancingFailure
